import React from "react";
import { useEffect } from "react";

// 1:1 copy of componentDidUpdate from class components, no support for dep array
export const useComponentDidUpdate = <T,>(callback: (prevProps: T) => void, props: T): void => {

    const isFirstRender = React.useRef(true);
    const prevProps = React.useRef<T>(props);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            prevProps.current = props;
            return;
        }
        callback(prevProps.current);
        prevProps.current = props;
    });
};